import { Col, Row, Typography } from "antd";
import React from "react";
import Page from "../../../common/components/Page";
import Shortcut from "../../../common/components/Shortcut";
import getConfigs from "../../../GetConfigs";

const ScheduleCriminalQuery = () => {
  const configurations = getConfigs([
    "ctDailyQuery",
    "ctAttorneyQuery",
    "ctArraignmentQuery",
    "ctOfficerQuery"
  ]);
  return (
    <Page>
      <Page.Title icon="balance-scale" title="Traffic/Criminal Case Schedule Query" />
      <Typography.Title level={5}>Schedule Type</Typography.Title>
      <Page.Content>
        <Row gutter={[12, 12]}>
          <Col xl={6} lg={6} md={12} sm={12} xs={24}>
            {configurations.ctDailyQuery?.toLowerCase() === "true" && <Shortcut icon="book" name="Daily Case Schedule Query" route="/tr-cr-query/daily-query" />}
          </Col>
          <Col xl={6} lg={6} md={12} sm={12} xs={24}>
            {configurations.ctArraignmentQuery?.toLowerCase() === "true" && <Shortcut icon="columns" name="Arraignment Case Schedule Query" route="/tr-cr-query/arraignment-query" />}
          </Col>
          <Col xl={6} lg={6} md={12} sm={12} xs={24}>
            {configurations.ctAttorneyQuery?.toLowerCase() === "true" && <Shortcut icon="cubes" name="Attorney Case Schedule Query" route="/tr-cr-query/attorney-query" />}
          </Col>
          <Col xl={6} lg={6} md={12} sm={12} xs={24}>
            {configurations.ctOfficerQuery?.toLowerCase() === "true" && <Shortcut icon="building" name="Agency Case Schedule Query" route="/tr-cr-query/agency-query" />}
          </Col>
        </Row>
      </Page.Content>
    </Page>
  );
};

export default ScheduleCriminalQuery;
